(function() {
    'use strict';

    angular.module('substoreApp.services')

        /**
         * Trust the following fields because we want to allow iframes, etc.
         *
         * Created by Mark von Zeschau on 31.08.2015
         */
        .factory('htmlTruster', ['$sce',
            function ($sce) {
                // please keep this list sorted alphabetically
                var fieldsToTrust = [
                    'accountInfoTextOptinSummary',
                    'afterOptinInfoText',
                    'beforeOptinInfoText',
                    'cataloguePromotionDisruptorText',
                    'catalogueRegularDisruptorText',
                    'dataTransferDenialText',
                    'descriptionAdministrationSelection',
                    'descriptionAdministrationSummary',
                    'emailTextProductChangeSummary',
                    'emailTextProductOrder',
                    'hintDescriptionAdministrationSelection',
                    'hintMyProducts',
                    'linkDescriptionAdministrationSummary',
                    'linkInfoText',
                    'linkInfoTextAdministrationSummary',
                    'minimumCommitmentPeriodOverrideText',
                    'minimumCommitmentPeriodOverrideTextMyProducts',
                    'minimumCommitmentPeriodText',
                    'minimumCommitmentPeriodTextMyProducts',
                    'orderCancellationDateQuestion',
                    'orderCancellationQuestion',
                    'orderCancellationConfirmButtonLabel',
                    'orderCancellationAbortButtonLabel',
                    'orderCancellationSucceeded',
                    'orderReactivationQuestion',
                    'orderReactivationSucceeded',
                    'orderReservationDeletionQuestion',
                    'orderReservationDeletionSucceeded',
                    'orderTerminationQuestion',
                    'orderTerminationSucceeded',
                    'parameterValueMyProducts',
                    'priceInformation',
                    'productAdministrationConfirmation',
                    'productAdministrationConfirmationHint',
                    'productChangeConfirmation',
                    'productChangeConfirmationAfterButtons',
                    'productChangeConfirmationBeforeButtons',
                    'productConfirmation',
                    'productConfirmationAfterButtons',
                    'productConfirmationBeforeButtons',
                    'productDescriptionCatalogue',
                    'productDescriptionChangeSelection',
                    'productDescriptionChangeSummary',
                    'productDescriptionDetails',
                    'productDescriptionOptinSummary',
                    'productDescriptionSelection',
                    'productDescriptionSummary',
                    'productGroupLowerDescriptionDetails',
                    'productGroupSelectionLabelDetails',
                    'productGroupUpperDescriptionDetails',
                    'productName',
                    'productOptinConfirmation',
                    'productOptinConfirmationAfterButtons',
                    'productOptinConfirmationBeforeButtons',
                    'productRequirementsDetails',
                    'productSubscriptionType',
                    'promotionPriceOverrideText',
                    'providerName',
                    'redirectHint',
                    'regularPriceOverrideText',
                    'reservationHint',
                    'textToBeConfirmedAdministrationSummary',
                    'textToBeConfirmedChangeSummary',
                    'textToBeConfirmedOptinSummary',
                    'textToBeConfirmedSummary'
                ];

                var trustInternal = function (wrapper, field) {
                    var text = wrapper[field];
                    if (text != null && (typeof text === 'string')) {
                        wrapper[field] = $sce.trustAsHtml(text);
                    }
                };

                var trust = function (textsWrapper, propertyName) {
                    if (propertyName == null) {
                        propertyName = 'texts';
                    }
                    for (var i = 0; i < fieldsToTrust.length; i++) {
                        var fieldToTrust = fieldsToTrust[i];
                        if (textsWrapper.length !== undefined) {
                            for (var j = 0; j < textsWrapper.length; j++) {
                                trustInternal(textsWrapper[j][propertyName], fieldToTrust);
                            }
                        } else {
                            trustInternal(textsWrapper[propertyName], fieldToTrust);
                        }
                    }
                };

                return {
                    trust: trust
                };

            }
        ]);
})();
